/**
 * School Data Management Component
 * Coláiste Lurgan Management System - School reference data configuration
 */

import React from 'react';
import CoursesManagement from './CoursesManagement';
import TravelLocationsManagement from './TravelLocationsManagement';
import SchoolYearsManagement from './SchoolYearsManagement';

export function SchoolData() {
  return (
    <div className="space-y-6">
      {/* Courses Management */}
      <CoursesManagement />

      {/* Travel Locations Management */}
      <TravelLocationsManagement />

      {/* School Years Management */}
      <SchoolYearsManagement />
    </div>
  );
}

export default SchoolData;
